import React from "react";

import {
  CommonLabel,
  InputAndLabelWrapper,
  InputRowWrapper,
  GeneralInput,
  RadioInputWrapper,
  RadioInputsWrapper,
  ErrorText,
} from "../../styles";
import { useTranslation } from "react-i18next";
import { useFormState, useWatch } from "react-hook-form";

function RadioQuestion({
  name = "",
  label,
  register,
  data = [],
  handleChange = null,
}) {
  const { t } = useTranslation();
  const nameRegister = register(name, { required: t("required") });

  const { errors } = useFormState();
  const fieldName = getName(name);

  const hasValue = useWatch({ name });

  const error =
    typeof fieldName === "string"
      ? errors?.[name]?.message
      : errors?.[fieldName?.[0]]?.[fieldName?.[1]]?.message;

  const hasError = error && !hasValue;

  function getName(input) {
    if (typeof input !== "string") return input;
    const isNested = input.includes(".");
    if (!isNested) return input;
    const arr = input.split(".");
    return arr;
  }

  return (
    <InputRowWrapper>
      <InputAndLabelWrapper>
        <CommonLabel>{label}</CommonLabel>
        <RadioInputsWrapper>
          {data?.map((item) => {
            return (
              <RadioInputWrapper key={item?.value}>
                <GeneralInput
                  type="radio"
                  value={item?.value}
                  id={name}
                  {...nameRegister}
                  onChange={(e) => {
                    nameRegister.onChange(e);
                    if (typeof handleChange === "function") {
                      handleChange(e);
                    }
                  }}
                />
                <CommonLabel htmlFor={name}>{item?.label}</CommonLabel>
              </RadioInputWrapper>
            );
          })}
          <ErrorText error={hasError}>
            {hasError ? error : "error placeholder"}
          </ErrorText>
        </RadioInputsWrapper>
      </InputAndLabelWrapper>
    </InputRowWrapper>
  );
}

export default RadioQuestion;
